// Original vocabulary. Role tags constrain where a noun may be used.
export default [
  {
    "id": "basketball",
    "role": "countable",
    "singular": "basketball",
    "plural": "basketballs",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "soccer-ball",
    "role": "countable",
    "singular": "soccer ball",
    "plural": "soccer balls",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "tennis-ball",
    "role": "countable",
    "singular": "tennis ball",
    "plural": "tennis balls",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "baseball",
    "role": "countable",
    "singular": "baseball",
    "plural": "baseballs",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "bat",
    "role": "countable",
    "singular": "bat",
    "plural": "bats",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "racket",
    "role": "countable",
    "singular": "racket",
    "plural": "rackets",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "medal",
    "role": "countable",
    "singular": "medal",
    "plural": "medals",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "whistle",
    "role": "countable",
    "singular": "whistle",
    "plural": "whistles",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "cone",
    "role": "countable",
    "singular": "cone",
    "plural": "cones",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "jersey",
    "role": "countable",
    "singular": "jersey",
    "plural": "jerseys",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ribbon",
    "role": "measurable",
    "singular": "ribbon",
    "plural": "ribbons",
    "tags": [
      "length"
    ]
  },
  {
    "id": "rope",
    "role": "measurable",
    "singular": "rope",
    "plural": "ropes",
    "tags": [
      "length"
    ]
  },
  {
    "id": "banner",
    "role": "measurable",
    "singular": "banner",
    "plural": "banners",
    "tags": [
      "length"
    ]
  },
  {
    "id": "strap",
    "role": "measurable",
    "singular": "strap",
    "plural": "straps",
    "tags": [
      "length"
    ]
  },
  {
    "id": "bag",
    "role": "container",
    "singular": "bag",
    "plural": "bags",
    "tags": []
  },
  {
    "id": "basket",
    "role": "container",
    "singular": "basket",
    "plural": "baskets",
    "tags": []
  },
  {
    "id": "box",
    "role": "container",
    "singular": "box",
    "plural": "boxes",
    "tags": []
  },
  {
    "id": "cart",
    "role": "container",
    "singular": "cart",
    "plural": "carts",
    "tags": []
  },
  {
    "id": "player",
    "role": "person",
    "singular": "player",
    "plural": "players",
    "tags": []
  },
  {
    "id": "coach",
    "role": "person",
    "singular": "coach",
    "plural": "coaches",
    "tags": []
  },
  {
    "id": "runner",
    "role": "person",
    "singular": "runner",
    "plural": "runners",
    "tags": []
  },
  {
    "id": "referee",
    "role": "person",
    "singular": "referee",
    "plural": "referees",
    "tags": []
  },
  {
    "id": "practice-session",
    "role": "action",
    "singular": "practice session",
    "plural": "practice sessions",
    "tags": []
  },
  {
    "id": "match",
    "role": "action",
    "singular": "match",
    "plural": "matches",
    "tags": []
  },
  {
    "id": "race",
    "role": "action",
    "singular": "race",
    "plural": "races",
    "tags": []
  },
  {
    "id": "training-session",
    "role": "action",
    "singular": "training session",
    "plural": "training sessions",
    "tags": []
  },
  {
    "id": "stadium",
    "role": "structure",
    "singular": "stadium",
    "plural": "stadiums",
    "tags": []
  },
  {
    "id": "scoreboard",
    "role": "structure",
    "singular": "scoreboard",
    "plural": "scoreboards",
    "tags": []
  },
  {
    "id": "court",
    "role": "place",
    "singular": "court",
    "plural": "courts",
    "tags": []
  },
  {
    "id": "field",
    "role": "place",
    "singular": "field",
    "plural": "fields",
    "tags": []
  }
];
